import { login, logout } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/storage'

const user = {
  state: {
    token: getToken(),
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password).then(response => {
          const tokenStr = response.data.myToken
          setToken(tokenStr)
          commit('SET_TOKEN', tokenStr)
          resolve()
        }).catch(error => {
          // 确保 reject 的是 Error 对象，并处理 error.message 可能是对象的情况
          let errorMsg = '登录失败';
          if (error) {
            if (error.message) {
              errorMsg = typeof error.message === 'string' ? error.message : JSON.stringify(error.message);
            } else {
              errorMsg = typeof error === 'string' ? error : JSON.stringify(error);
            }
          }
          const err = error instanceof Error ? error : new Error(errorMsg);
          reject(err);
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout().then(() => {
          commit('SET_TOKEN', '')
          removeToken()
          resolve()
        }).catch(error => {
          // 确保 reject 的是 Error 对象，并处理 error.message 可能是对象的情况
          let errorMsg = '登出失败';
          if (error) {
            if (error.message) {
              errorMsg = typeof error.message === 'string' ? error.message : JSON.stringify(error.message);
            } else {
              errorMsg = typeof error === 'string' ? error : JSON.stringify(error);
            }
          }
          const err = error instanceof Error ? error : new Error(errorMsg);
          reject(err);
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user
